// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"f758b32f","842":"8df647c5","893":"88d5e677"}[chunkId] + ".chunk.js";
};